import { useTranslation } from "react-i18next";
import { DaysCountDown, GetUserProfile } from "./general";
import { AUDateFormat, CNDateTimeFormat } from "./date";
import { NO_PackageKey, PackageKey } from "../constants/options";
import { GetMiniUrl } from "./mini";
import { t } from "i18next";
import { IsEmptyStr } from "./field-validation";
import moment from "moment";

export enum PackageFeatures {
  //Personal
  BASIC = 1,
  WEB = 2,
  //Clinic
  APPOINTMENT = 3,
  PATIENT_PRESCRIPTION_AND_PAYMENT = 4,
  AI = 5,
}

export const IsClinicPackage = (features: PackageFeatures[]) => {
  return features.includes(PackageFeatures.APPOINTMENT);
};

export const IsPersonalPackage = (features: PackageFeatures[]) => {
  return !IsClinicPackage(features);
};

export const IsPersonalPackageBinded = (pkg: any): boolean => {
  return pkg?.features?.length == 2 && (pkg?.features?.find((f: any) => f.id == PackageFeatures.WEB) || pkg?.features?.find((f: any) => f == PackageFeatures.WEB));
}

export const ComparePackageLv = (
  featuresA: PackageFeatures[],
  featuresB: PackageFeatures[]
) => {
  return featuresA.length - featuresB.length;
};

const IsExpired = (endDate: string) => {
  const now = new Date();
  const end = new Date(endDate);
  return now.getTime() > end.getTime();
};

export const HasFeature = (features: PackageFeatures[], clinicId?: number) => {
  // const mockFeatures: any = {
  //   features: [PackageFeatures.BASIC, PackageFeatures.WEB],
  //   endDate: "2077-01-01T00:00:00.000",
  //   clinicPackages: [
  //     {
  //       clinicId: 23,
  //       features: [
  //         PackageFeatures.BASIC,
  //         PackageFeatures.WEB,
  //         PackageFeatures.APPOINTMENT,
  //         PackageFeatures.PRESCRIPTION_AND_PAYMENT,
  //         PackageFeatures.AI,
  //       ],
  //       endDate: "2077-01-01T00:00:00.000",
  //     },
  //   ],
  // };
  // console.log("HasFeature", features, clinicId);
  const currentClinicId = GetUserProfile().currentClinicId || null;
  let has: boolean = true;
  const userFeatures: any = GetUserProfile()?.packagePermissions;
  // const userFeatures: any = mockFeatures;

  let checkedFeatures: any = { ...userFeatures };
  if (IsExpired(checkedFeatures.endDate)) {
    checkedFeatures.features = [PackageFeatures.BASIC];
  }

  // checkedFeatures?.clinicPackages?.map((c: any) => {
  //   if (IsExpired(c.endDate)) {
  //     c.features = [PackageFeatures.BASIC];
  //   }
  // });

  features.map((f: any) => {
    let clinicHas: boolean = true;

    let thisClinicId = clinicId || currentClinicId;
    // if (!clinicId) return false;
    const clinic = checkedFeatures?.clinicPackages.find(
      (c: any) => c.clinicId == thisClinicId
    );

    if (!clinic?.features.includes(f)) {
      clinicHas = false;
    }

    let personHas: boolean = true;
    if (!checkedFeatures.features.includes(f)) {
      personHas = false;
    }

    if (!clinicHas && !personHas) {
      has = false;
    }
  });
  return has;
};

export const GetClinicPackageStringById = (clinicId?: number) => {
  let clinicPackageString = NO_PackageKey;
  if (HasFeature([PackageFeatures.AI], clinicId)) {
    clinicPackageString = "3";
  } else if (
    HasFeature([PackageFeatures.PATIENT_PRESCRIPTION_AND_PAYMENT], clinicId)
  ) {
    clinicPackageString = "2";
  } else if (HasFeature([PackageFeatures.APPOINTMENT], clinicId)) {
    clinicPackageString = "1";
  } else if (HasFeature([PackageFeatures.WEB], clinicId)) {
    clinicPackageString = "0";
  }
  return clinicPackageString;
};

export const GetPackageLevelByFeatures = (features: any[]) => {
  console.log("GetPackageLevelByFeatures", features);
  let featureIds: number[] = features.map((f: any) => (f.id ? f.id : f));
  if (featureIds.includes(PackageFeatures.AI)) {
    return 3;
  } else if (
    featureIds.includes(PackageFeatures.PATIENT_PRESCRIPTION_AND_PAYMENT)
  ) {
    return 2;
  } else if (featureIds.includes(PackageFeatures.APPOINTMENT)) {
    return 1;
  } else if (featureIds.includes(PackageFeatures.WEB)) {
    return 0;
  }
  return 0;
};

export const GetPackageNameByFeatures = (features: PackageFeatures[]) => {
  let str = "";
  const getAppendStr = (appenStr: string) => {
    return (IsEmptyStr(str) ? "" : ` + `) + appenStr;
  }
  if (features.includes(PackageFeatures.WEB)) str += t('WEB');
  if (features.includes(PackageFeatures.AI)) str += getAppendStr("AI");
  else if (features.includes(PackageFeatures.PATIENT_PRESCRIPTION_AND_PAYMENT)) str += getAppendStr(t('SHORT_PRESCRIPTION'));
  else if (features.includes(PackageFeatures.APPOINTMENT)) str += getAppendStr(t('SHORT_APPOINTMENT'));
  return str + t('SHORT_PACKAGE');
}

export const HasFeaturePermission = (path: string) => {
  let hasPermission: boolean = true;

  let appointmentPath: string[] = ["/appointment", GetMiniUrl("/appointment"), GetMiniUrl("/dashboard")];
  if (appointmentPath.find((p: string) => path.includes(p)))
    return HasFeature([PackageFeatures.APPOINTMENT]);

  let prescriptionPath: string[] = ["/prescription", GetMiniUrl("/prescription"), "/herb-management", "/patient-list", GetMiniUrl("/dashboard")];
  if (prescriptionPath.find((p: string) => path.includes(p)))
    return HasFeature([PackageFeatures.PATIENT_PRESCRIPTION_AND_PAYMENT]);
  return hasPermission;
};

export const PACKAGE_LVL_COLOR: { levelNo: number; bgColor: string }[] = [
  {
    levelNo: 0,
    bgColor:
      "linear-gradient(140deg,rgba(88, 108, 135, 0.84) 55%, rgba(200, 215, 235, 1) 100%)",
  },
  {
    levelNo: 1,
    bgColor:
      "linear-gradient(140deg,rgba(60, 166, 46, 0.84) 55%, rgba(180, 232, 167, 1) 100%)",
  },
  {
    levelNo: 2,
    bgColor:
      "linear-gradient(140deg,rgba(46, 84, 166, 0.84) 55%, rgba(167, 212, 232, 1) 100%)",
  },
  {
    levelNo: 3,
    bgColor:
      "linear-gradient(140deg,rgba(51, 4, 92, 0.84) 55%, rgba(218, 170, 242, 1) 100%)",
  },
  {
    levelNo: 4,
    bgColor:
      "linear-gradient(140deg,rgba(255, 174, 0, 0.84) 55%, rgba(218, 197, 117, 1) 100%)",
  },
];

export const EXPIRE_NOTICE_DAY = 7;
export const PACKAGE_END_DATA_NULL_PLACEHOLDER = "3000-01-01T00:00:00";

export const PACKAGE_FILTER = [
  { id: 1, typeLabel: t('FOR_PERSONAL'), label: "", key: PackageKey.KEY_PERSONAL, users: 0 },
  { id: 2, typeLabel: t('FOR_CLINIC'), label: `1${t('USERS')}`, key: "", users: 1 },
  { id: 3, typeLabel: t('FOR_CLINIC'), label: `2${t('USERS')}`, key: "", users: 2 },
  { id: 4, typeLabel: t('FOR_CLINIC'), label: `3${t('USERS')}`, key: "", users: 3 },
  { id: 5, typeLabel: t('FOR_CLINIC'), label: `4${t('USERS')}`, key: "", users: 4 },
  { id: 6, typeLabel: t('FOR_CLINIC'), label: `5${t('USERS')}`, key: "", users: 5 },
  { id: 7, typeLabel: t('FOR_CLINIC'), label: `6${t('USERS')}`, key: "", users: 6 },
  { id: 8, typeLabel: t('FOR_CLINIC'), label: `7${t('USERS')}`, key: "", users: 7 },
  { id: 9, typeLabel: t('FOR_CLINIC'), label: `8${t('USERS')}`, key: "", users: 8 },
  { id: 10, typeLabel: t('FOR_CLINIC'), label: `9${t('USERS')}`, key: "", users: 9 },
  { id: 11, typeLabel: t('FOR_CLINIC'), label: `10+${t('USERS')}`, key: "", users: 0 },
];
export const CLINIC_PACKAGE_FILTER = [
  { id: 1, label: t('WITHOUT_PERSONAL_WEBSITE'), features: [PackageFeatures.APPOINTMENT, PackageFeatures.PATIENT_PRESCRIPTION_AND_PAYMENT, PackageFeatures.AI] },
  { id: 2, label: t('INCLUDES_PERSONAL_WEBSITE'), features: [PackageFeatures.APPOINTMENT, PackageFeatures.PATIENT_PRESCRIPTION_AND_PAYMENT, PackageFeatures.AI, PackageFeatures.WEB] },
]

export enum AddonCategory {
  ALL = 0,
  BY_USAGE = 1,
  FIXED_PRICE = 2,
}

export const BillingCyclePeriod = [
  { unit: "Week", value: 7, label: "Weekly" },
  { unit: "Fortnight", value: 14, label: "Fortnightly" },
  { unit: "Month", value: 31, label: "Monthly" },
  { unit: "Quarter", value: 93, label: "Quarterly" },
  { unit: "Half Year", value: 183, label: "Bi_annually" },
  { unit: "Year", value: 366, label: "Annually" },
];

export const GetAddonPrice = (addon: any) => {
  if (addon.categoryId == AddonCategory.BY_USAGE) return addon.pricePerUnit ?? 0;
  return addon.price ?? 0;
}

export const GetAddonPriceLabel = (addon: any, categoryId?: AddonCategory) => {
  const category = categoryId ?? addon.categoryId;
  const periodLabel = t((BillingCyclePeriod.find((b: any) => b.value == addon.billingCycleDays)?.unit ?? "--").toUpperCase());
  if (category == AddonCategory.BY_USAGE) return `${addon.pricePerUnit ?? "--"} ${t('PER_MESSAGE')} / ${periodLabel}`
  return `${addon.price ?? "--"} / ${periodLabel}`
}

export const MapAddonPriceType = (addon: any, categoryId?: AddonCategory) => {
  return {
    ...addon,
    categoryId: categoryId ?? (addon.categoryId == AddonCategory.ALL ? AddonCategory.BY_USAGE
      : addon.categoryId)
  };
}

export const ConstructDayLabel = (date: string, isDetailDateRequired: boolean = false) => {
  if (IsEmptyStr(date)) return "--";
  let str = "";
  const timeDiff = DaysCountDown(date);
  if (timeDiff == 0) return t('TODAY');

  str += Math.abs(timeDiff);
  if (timeDiff < 0) str += t('E_DAYS_AGO');
  else str += t('E_DAYS_LEFT');
  if (isDetailDateRequired) return str += `(${moment(date).format(AUDateFormat)})`;
  return str;
}

export const ConstructDayLabelByNoDays = (noDays: number, isDetailDateRequired: boolean = false) => {
  if (noDays == 0) return t('TODAY');
  let str = "";
  str += noDays;
  if (noDays < 0) str += t('E_DAYS_AGO');
  else str += t('E_DAYS_LEFT');
  if (isDetailDateRequired) return str += `(${noDays})`;
  return str;
}

export enum PaymentHistoryCategory {
  PACKAGE = 1,
  ADDON = 2,
}

export const IsCreateCardRequired = (isCreateCard: boolean, addons: any[], myCards: any[]) => {
  if (myCards.length > 0) return isCreateCard;
  if (addons.some((a) => Number(GetAddonPrice(a)) > 0)) return true;
  return isCreateCard;
}